import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DivideIcon as LucideIcon, ChevronRight } from 'lucide-react';
import { AppleIcon } from '../../Icon';

interface NavItemProps {
  path: string;
  icon: LucideIcon;
  label: string;
  isActive: boolean;
  id?: string;
  isCollapsed?: boolean;
  gradient?: {
    from: string;
    to: string;
    darkFrom?: string;
    darkTo?: string;
  };
}

const NavItem: React.FC<NavItemProps> = ({ 
  path, 
  icon: Icon, 
  label, 
  isActive, 
  id, 
  isCollapsed = false,
  gradient 
}) => {
  const defaultGradient = {
    from: 'from-blue-400',
    to: 'to-blue-600',
    darkFrom: 'dark:from-blue-500',
    darkTo: 'dark:to-blue-700'
  };

  return (
    <NavLink
      to={path}
      className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${
        isActive 
          ? 'bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/50 dark:to-indigo-900/50 text-blue-600 dark:text-blue-400' 
          : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800'
      }`}
      id={id}
    >
      <AppleIcon
        icon={Icon}
        gradient={gradient || defaultGradient}
        size="sm"
        className="flex-shrink-0"
      />
      {!isCollapsed && (
        <span className="ml-3 font-medium">{label}</span>
      )}
      {isActive && !isCollapsed && (
        <motion.div
          layoutId="activeIndicator"
          className="ml-auto"
          initial={false}
        >
          <ChevronRight className="w-5 h-5 text-blue-600 dark:text-blue-400" />
        </motion.div>
      )}
    </NavLink>
  );
};

export default NavItem;